import { Component, Input, OnInit } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-single-person',
  templateUrl: './sample-single-person.component.html',
  styleUrls: ['./sample-single-person.component.scss']
})
export class SampleSinglePersonComponent implements OnInit {

  @Input() block: any;
  public domainWebsite = environment.urlApi;

  constructor(
    private helpersService: HelpersService, 
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {}

  public setStringDipartimento(items: any, bundle: string): string {
    let stringItem: string = '';
    items.forEach((el: any, idx: number) => {
      if (bundle === 'docente') {
        if (idx < items.length - 1) {
          stringItem += el.name + ', ';
        } else {
          stringItem += el.name;
        }
      } else {
        if (idx < items.length - 1) {
          stringItem += this.helpersService.retriveLinkTagA(el, 'a').title + ', ';
        } else {
          stringItem += this.helpersService.retriveLinkTagA(el, 'a').title;
        }
      }
    });
    return stringItem;
  }

  public toPage(field_titolo: string): string {
    return this.helpersService.retriveLinkTagA(field_titolo, 'a').link;
  }

  public setImage(item: string): any {
    let personImage = {
      url: this.domainWebsite + this.helpersService.retrieveImage(item, 'src'),
      tagAlt: this.helpersService.retrieveImage(item, 'alt')
    };
    return personImage;
  }

}
